/**
 * This class represent the criterias that are usefull (or not) to handleChangeOfSelectFold search display
 * everything is not usefull for the front-office (just there if needed in the future)
 */
export class ConsultCriteria {
  /**
   * If the criteria should be display (useless)
   */
  bDisplay: boolean;

  /**
   * if they are restrictions (like a select) for filters (useless)
   */
  bRestrictToSuggestedValues: boolean;

  /**
   * always DISPLAY for criterias (useless)
   */
  sCategory: string;

  /**
   * Libelle used to guide user for typing (useless)
   */
  sHelpI18n: string;

  /**
   * Libelle use for filters form (useless)
   */
  sLibI18n: string;

  /**
   * Name of the i18n format
   */
  sNameI18n: string;

  /**
   * Name of the criteria to request the back-office (useless)
   */
  sNameId: string;

  /**
   * useless on front
   */
  sStorageName: string;

  /**
   * useless on front
   */
  sStorageType: string;

  /**
   * useless on front
   */
  sTypeData: string;

  constructor(bDisplay: boolean, bRestrictToSuggestedValues: boolean, sCategory: string,
              sHelpI18n: string, sLibI18n: string, sNameI18n: string,
              sNameId: string, sStorageName: string, sStorageType: string,
              sTypeData: string) {
    this.bDisplay = bDisplay;
    this.bRestrictToSuggestedValues = bRestrictToSuggestedValues;
    this.sCategory = sCategory;
    this.sHelpI18n = sHelpI18n;
    this.sLibI18n = sLibI18n;
    this.sNameI18n = sNameI18n;
    this.sNameId = sNameId;
    this.sStorageName = sStorageName;
    this.sStorageType = sStorageType;
    this.sTypeData = sTypeData;
  }

}
